import React from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, View } from '@react-pdf/renderer'

import { Line } from '@generators/pdfComponents/Line'
import Text from './Text'
import { Status } from './Status'

import colors from '@settings/styleSettings'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: -12,
    marginBottom: 12,
  },
  text: {
    fontSize: 10,
    fontFamily: 'Inter-Bold',
    color: colors.strongGray,
  },
})

const InfoLine = ({ text, informed }) => (
  <>
    <View style={styles.container}>
      <Text style={styles.text}>{text}</Text>
      <Status
        text={informed ? 'Sim' : 'Não'}
        textColor={informed ? colors.strongRed : colors.primary}
      />
    </View>
    <Line style={{ marginBottom: 24 }} />
  </>
)

InfoLine.propTypes = {
  text: PropTypes.string,
  informed: PropTypes.bool,
}

InfoLine.defaultProps = {
  text: '',
  informed: null,
}

export default InfoLine
